module.exports = __webpack_public_path__ + "img/Terpin.0b92bfed.jpg";